/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";

import Header from "../../Common/Header";
import TextEditor from "../../Common/Editor";
import useCreateAssessment from "./useCreateAssessment";
import "./CreateAssessment.scss";
import CreateAssessmentKitTopic from "./components/CreateAssessmentKitTopic";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MainLayout from "../../Common/MainLayout";

export default (props) => {
  const {
    formData,
    saveLoading,
    outroNoteEditor,
    welcomeNoteEditor,
    formInputsError,
    continueLoading,
    previewLoading,
    dueDate,
    loading,
    onTitleChange,
    onCancelClick,
    onSaveClick,
    onInputChange,
    openEditor,
    onDeleteClick,
    calculateAssessmentEstimatedTime,
  } = useCreateAssessment(props);
  return (
    <MainLayout
      pageName={
        formData && formData?.title
          ? formData && formData?.title
          : "Create Assessment"
      }
    >
      <div className="create-interview footer-gap">
        <div className="top bg-grey pb-4">
          <Container className="d-flex justify-content-between align-items-center">
            <h2 className="text-dark text-capitalize">
              {formData?.title && formData.title.length > 0
                ? formData?.title
                : "Create Video Assessment Kit"}
            </h2>
            <span className="d-flex align-items-center ml-2">
              <button className="btn btn-outline-dark" onClick={onCancelClick}>
                {"Cancel & Return"}
              </button>
              <button
                className="btn btn-light ml-2"
                onClick={() => onSaveClick("preview", "draft")}
              >
                {previewLoading ? (
                  <Spinner animation="border" variant="primary" />
                ) : (
                  "Save & Preview"
                )}
              </button>
            </span>
          </Container>
        </div>

        <Container>
          <Row>
            <Col lg={11}>
              <div className="job-detail mt-5 bg-grey-5 px-3">
                <div className="top bg-grey-2 py-3 px-4 mx-n3">
                  <h3 className="font-weight-medium">Welcome page intro</h3>
                </div>
                <Row>
                  <Col lg={9}>
                    <div className="form-group mb-0 py-3">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Title
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Enter Assessment Kit Title"
                        name="title"
                        onBlur={(e) => onTitleChange(e)}
                        defaultValue={formData && formData?.title}
                      />
                      {formInputsError.title &&
                      formInputsError.title.length > 0 ? (
                        <span className="text-danger mt-1 line-height-14 d-inline-block">
                          {formInputsError.title}
                        </span>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="form-group mb-0 py-3">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Due date
                      </p>
                      <div>
                        <DatePicker
                          dateFormat="YYYY-MM-DD"
                          onChange={(date) => {
                            onInputChange({
                              target: { value: date, name: "due_date" },
                            });
                          }}
                          className="form-control bg-transparent"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          value={dueDate}
                          placeholderText={
                            dueDate ? dueDate : "Select Due Date"
                          }
                        />
                      </div>
                      {formInputsError.due_date &&
                      formInputsError.due_date.length > 0 ? (
                        <span className="text-danger mt-1 line-height-14 d-inline-block">
                          {formInputsError.due_date}
                        </span>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="form-group mb-0 py-3">
                      <p className="font-weight-medium">
                        Welcome note (optional)
                      </p>
                      <div>
                        {welcomeNoteEditor ? (
                          <TextEditor
                            htmlData={formData && formData?.welcome_note}
                            getHtmlData={(data) =>
                              onInputChange({
                                target: { value: data, name: "welcome_note" },
                              })
                            }
                          />
                        ) : (
                          <div
                            className="note form-control placeholder text-grey-4 fs-smallest"
                            onClick={() => openEditor("welcome_note")}
                          >
                            {formData?.welcome_note &&
                            formData?.welcome_note.length > 0 ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: formData?.welcome_note,
                                }}
                                className="pt-2"
                              ></div>
                            ) : (
                              "Click to enter welcome notes here."
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className="top bg-grey-2 py-3 px-4 mx-n3 d-flex justify-content-between align-items-center">
                  <h3 className="font-weight-medium pb-2">Questions</h3>
                  <span className="">
                    Estimated Time: {calculateAssessmentEstimatedTime()} mins
                  </span>
                </div>
                <div>
                  <CreateAssessmentKitTopic formData={formData} />
                </div>

                {formInputsError.topics && formInputsError.topics.length > 0 ? (
                  <span className="text-danger mt-1 line-height-14 d-inline-block">
                    {formInputsError.topics}
                  </span>
                ) : null}

                <div className="top bg-grey-2 py-3 px-4 mx-n3">
                  <h3 className="font-weight-medium">Epilogue</h3>
                </div>

                <Row>
                  <Col lg={12}>
                    <div className="form-group mb-0 py-3">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Title
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Thanks for sharing this video interview with Zydelo"
                        name="epilogue_title"
                        onChange={(e) => onInputChange(e)}
                        defaultValue={formData && formData?.epilogue_title}
                      />
                      {formInputsError.epilogue_title &&
                      formInputsError.epilogue_title.length > 0 ? (
                        <span className="text-danger mt-1 line-height-14 d-inline-block">
                          {formInputsError.epilogue_title}
                        </span>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="form-group mb-0 py-3">
                      <p className="font-weight-medium">
                        Outro note
                      </p>
                      <div>
                        {outroNoteEditor ? (
                          <TextEditor
                            htmlData={formData && formData?.epilogue_outro_note}
                            getHtmlData={(data) =>
                              onInputChange({
                                target: {
                                  value: data,
                                  name: "epilogue_outro_note",
                                },
                              })
                            }
                          />
                        ) : (
                          <div
                            className="note form-control placeholder text-grey-4 fs-smallest"
                            onClick={(e) => openEditor("epilogue_outro_note")}
                          >
                            {formData?.epilogue_outro_note &&
                            formData?.epilogue_outro_note.length > 0 ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: formData?.epilogue_outro_note,
                                }}
                                className="pt-2"
                              ></div>
                            ) : (
                              "Click to enter epilogue notes here."
                            )}
                          </div>
                        )}
                        {formInputsError?.epilogue_outro_note &&
                        formInputsError.epilogue_outro_note.length > 0 ? (
                          <span className="text-danger mt-1 line-height-14 d-inline-block">
                            {formInputsError.epilogue_outro_note}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className="action py-3 border-top mt-4">
                  <button
                    className="btn btn-primary"
                    onClick={() => onSaveClick("save", "draft")}
                  >
                    {saveLoading ? (
                      <Spinner animation="border" variant="white" />
                    ) : (
                      "Save all changes"
                    )}
                  </button>
                  <button
                    className="btn btn-outline-light ml-3"
                    onClick={() => onSaveClick("continue", "publish")}
                  >
                    {continueLoading ? (
                      <Spinner animation="border" variant="primary" />
                    ) : (
                      "Publish and continue"
                    )}
                  </button>
                  {formData?.id && (
                    <>
                      {loading ? (
                        <div className="d-inline-block ml-4">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : (
                        <button
                          className="border-0 bg-transparent text-danger ml-3 text-nowrap"
                          onClick={() => onDeleteClick()}
                        >
                          <FontAwesomeIcon
                            icon={faMinusCircle}
                            className="mr-2"
                          />
                          Delete
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </MainLayout>
  );
};
